export enum Socials {
  Instagram = 'instagram',
  Twitter = 'twitter',
  Tiktok = 'tiktok',
}

export type SocialsType = 'instagram' | 'twitter' | 'tiktok'
